import type { BoxProps, IconProps, TextProps } from '@chakra-ui/react';
import { Box, Collapse, HStack, Icon, Text } from '@chakra-ui/react';
import { ChevronRight } from '@cronos-app/icons';
import type { ReactNode } from 'react';
import { useState } from 'react';

export const CollapseWrapper = ({
  title,
  titleImage,
  children,
  boxProps,
  titleProps,
  iconProps,
}: {
  title: ReactNode;
  titleImage?: ReactNode;
  children: ReactNode;
  boxProps?: BoxProps;
  titleProps?: TextProps;
  iconProps?: Omit<IconProps, 'as'>;
}) => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <Box rounded="8px" {...boxProps}>
      <HStack
        onClick={() => setCollapsed(!collapsed)}
        cursor="pointer"
        pos="relative"
        justifyContent="space-between"
      >
        <Text textStyle="body3Bold" color="#159DFF" {...titleProps}>
          {title}
        </Text>
        <Icon
          as={ChevronRight}
          color="#159DFF"
          boxSize="5"
          transform={collapsed ? 'rotate(90deg)' : 'rotate(-90deg)'}
          transition="transform 0.2s"
          {...iconProps}
        />
        {titleImage}
      </HStack>
      <Collapse in={!collapsed}>{children}</Collapse>
    </Box>
  );
};
